import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { Location } from '@angular/common';
import { UntypedFormGroup } from '@angular/forms';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { InspectionPluginService } from '../../../shared/services';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ModalComponent } from '../../../modal/modal.component';

@Component({
    template: '',
    standalone: false
})
export class BaseInstallationEditPageComponent extends BaseModalPageComponent {
  editForm: UntypedFormGroup;
  inspectionId: string;
  pointId: string;
  pluginId: string;

  public processing = false;

  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('pluginDeleteConfirm', { static: true }) pluginDeleteConfirm: ConfirmComponent;

  constructor(
    location: Location,
    protected service: InspectionPluginService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router
  ) {
    super(location);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  public gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  public deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public openDeleteConfirm() {
    this.pluginDeleteConfirm.open();
  }

  public cancel() {
    this.goToBack();
  }

  public initRoute(): Observable<void> {
    return this.activatedRoute.params.pipe(
      map((params: Params) => {
        const id = params['inspectionId'];
        if (id == null) this.router.navigate([this.inspectionsRoute]);

        this.inspectionId = id;

        const pointId = params['pointId'];
        this.pointId = pointId;

        const pluginId = params['pluginId'];
        if (pluginId == null) this.goToBack();

        this.pluginId = pluginId;
      })
    );
  }
}
